import User, {Role} from '../core/auth/user';

export default class ClientTip {

  static deserialize(dto: ClientTipDto): ClientTip {
    return new ClientTip(
      dto.id,
      dto.auteurId,
      dto.auteurNummer,
      dto.auteurRol,
      dto.clientId,
      dto.dienstId,
      dto.categorieId,
      dto.taakId,
      dto.content,
      new Date(dto.creatieTijdstip),
      new Date(dto.laatstGewijzigdeTijdstip),
    );
  }

  constructor(private id: string,
              private auteurId: string,
              private auteurNummer: string,
              private auteurRol: Role,
              private clientId: string,
              private dienstId: string,
              private categorieId: string,
              private taakId: string,
              private content: string,
              private creatieTijdstip: Date,
              private laatstGewijzigdeTijdstip: Date,
  ) {
  }

  getId(): string {
    return this.id;
  }

  getAuteurId(): string {
    return this.auteurId;
  }

  hasAuteurId(auteurId: string): boolean {
    return this.auteurId === auteurId;
  }

  getAuteurNummer(): string {
    return this.auteurNummer;
  }

  getAuteurRol(): Role {
    return this.auteurRol;
  }

  hasAuteurRole(role: Role): boolean {
    return this.auteurRol === role;
  }

  isFromRegioverantwoordelijke(): boolean {
    return this.hasAuteurRole(Role.REGIOVERANTWOORDELIJKE);
  }

  getClientId(): string {
    return this.clientId;
  }

  getDienstId(): string {
    return this.dienstId;
  }

  getCategorieId(): string {
    return this.categorieId;
  }

  getTaakId(): string {
    return this.taakId;
  }

  getContent(): string {
    return this.content;
  }

  getCreatieTijdstip(): Date {
    return this.creatieTijdstip;
  }

  getLaatstGewijzigdeTijdstip(): Date {
    return this.laatstGewijzigdeTijdstip;
  }

  isEditableBy(user: User): boolean {
    return this.hasAuteurId(user.id)
      || (this.isFromRegioverantwoordelijke() && user.isRegioverantwoordelijke());
  }

  isDeletableBy(user: User): boolean {
    return this.hasAuteurId(user.id) || user.isRegioverantwoordelijke();
  }
}

export interface ClientTipDto {
  id: string;
  auteurId: string;
  auteurNummer: string;
  auteurRol: Role;
  clientId: string;
  dienstId: string;
  categorieId: string;
  taakId: string;
  content: string;
  creatieTijdstip: string;
  laatstGewijzigdeTijdstip: string;
}
